import DialogBase from "../libs/DialogBase";
import Util from "../libs/Util";
import gsap from "../libs/gsap.min";
import DialogPassengerRoom from "./_parts/DialogPassengerRoom";

export default class DialogPassenger extends DialogBase {
  static EVENT_UPDATE_SELECT_DISPLAY = "eventUpdateSelectDisplay";

  constructor(_searchParentEl,_masterData) {
    super("#dialog_passenger");

    this.CL_OPEN = 'isOpen';
    this.CL_DISABLED = 'isDisabled';

    this.rooms = [];
    this.displayText = "";

    let _defaultData = {
      adtnum1:1,
      chdnum1:0,
      chdage1:"",
      roomnum:1
    };
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has("roomnum")) _defaultData.roomnum = parseInt(urlParams.get("roomnum"));
    for(let i=1;i<=8;i++){
      if(urlParams.has("adtnum"+i)){
        _defaultData["adtnum"+i] = parseInt(urlParams.get("adtnum"+i));
      }
      if(urlParams.has("chdnum"+i)){
        _defaultData["chdnum"+i] = parseInt(urlParams.get("chdnum"+i));
      }
      if(urlParams.has("chdage"+i)){
        _defaultData["chdage"+i] = urlParams.get("chdage"+i);
      }
    }

    this.bg = this.target.querySelector('.gl_common_dialog__bg');
    this.window = this.target.querySelector('.gl_common_dialog__window');

    this.insertTarget = this.target.querySelector('.-js-insert_target');

    this.btnRoomAdd = this.target.querySelector('.-btn_room_add button');
    this.btnRoomAdd.addEventListener('click',()=>{
      this.addRoom();
    });

    this.btnTarget = _searchParentEl.querySelector('.js-dialog_passenger');
    this.btnTarget.addEventListener('click',this.onClickOpen.bind(this));

    this.btnSubmit = this.target.querySelector('.-btn_submit button');
    this.btnSubmit.addEventListener('click',this.onClickSubmit.bind(this));

    window.addEventListener('resize',this.onResize.bind(this));

    this.updateRoomEl = this.updateRoom.bind(this);
    this.deleteRoomEl = this.deleteRoom.bind(this);

    this.beforeData = _defaultData;
    this.masterData = _masterData;

    this.onInit(_masterData,_defaultData);
  }

  onInit(data,_defaultData){
    for(let i=0;i<_defaultData.roomnum;i++){
      const n = i + 1;
      this.addRoom({
        adtnum:_defaultData["adtnum"+n],
        chdnum:_defaultData["chdnum"+n],
        chdage:_defaultData["chdage"+n]
      });
    }
    this.updateSelectDisplay();
  }

  addRoom(_defaultData = {adtnum:1,chdnum:0,chdage:""}){
    const room = new DialogPassengerRoom(this.rooms.length,this.insertTarget,_defaultData);
    room.el.addEventListener(DialogPassengerRoom.EVENT_DELETE,this.deleteRoomEl);
    room.el.addEventListener(DialogPassengerRoom.EVENT_UPDATE_COUNT,this.updateRoomEl);
    this.rooms.push(room);

    this.updateBtnRoomAdd();
  }

  updateRoom(e){
    this.updateSelectDisplay();
  }

  deleteRoom(e){
    const room = this.rooms.splice(e.detail.index,1);
    room[0].el.removeEventListener(DialogPassengerRoom.EVENT_DELETE,this.deleteRoomEl);
    room[0].el.removeEventListener(DialogPassengerRoom.EVENT_UPDATE_COUNT,this.updateRoomEl);
    room[0].onDelete();
    room[0] = null;
    this.rooms.forEach((item,index)=>item.updateIndex(index));

    this.updateBtnRoomAdd();
  }

  updateBtnRoomAdd(){
    if(this.rooms.length >= 8){
      this.btnRoomAdd.classList.add(this.CL_DISABLED);
    } else {
      this.btnRoomAdd.classList.remove(this.CL_DISABLED);
    }

    this.updateSelectDisplay();
  }

  onResize(){
    if(this.isOpen && !this.isSp) this.setDialogWindowPosition();
  }

  onMediaQueryOnChange(e){
    this.isSp = e.matches;

    if(this.window) {
      this.window.style.opacity = "";
      this.window.style.transform = "";
      this.bg.style.opacity = "";
      this.bg.style.transform = "";
    }

    if(this.isSp){
      if(this.isOpen) {
        this.setOverflowChange(true);
      }
    } else {
      if(this.isOpen) {
        this.setOverflowChange(false);
      }
    }

    this.setDialogWindowPosition();
  }

  setOverflowChange(_flag){
    if(_flag){
      let p = Util.getWindowScrollWidth();
      this.html.style.overflow = "hidden";
      this.body.style.overflow = "hidden";
      this.body.style.paddingRight = p+"px";
    } else {
      this.html.style.overflow = "";
      this.body.style.overflow = "";
      this.body.style.paddingRight = "";
    }
  }

  setDialogWindowPosition(){
    if(!this.window) return;

    if(this.isSp) {
      this.window.style.left = '';
      this.window.style.top = '';
    } else {
      const rect = this.btnTarget.getBoundingClientRect();
      const left = rect.left + window.scrollX + rect.width/2;
      this.window.style.left = left + 'px';
      const top = rect.top + window.scrollY;
      this.window.style.top = top + 'px';
    }
  }

  updateSelectDisplay(){
    let adtnum = 0;
    let chdnum = 0;
    let roomnum = this.rooms.length;
    this.rooms.forEach(room=>{
      adtnum += room.adtCount.count;
      chdnum += room.chdCount.count;
    });
    this.displayText = `大人${adtnum}名,子供${chdnum}名,${roomnum}部屋`;
    this.el.dispatchEvent(new CustomEvent(DialogPassenger.EVENT_UPDATE_SELECT_DISPLAY));
  }

  onClickOpen(e){
    if(this.isOpen) return;

    this.setDialogWindowPosition();

    this.onOpen();
  }

  onOpen() {
    this.isOpen = true;

    this.beforeDays = {start:this.startDays,end:this.endDays};

    gsap.set([this.bg,this.window],{
      ...(this.isSp?{y:"100%"}:{opacity:0})
    });
    this.target.style.display = "block";
    this.onOpenBefore();

    gsap.killTweensOf([this.bg,this.window]);

    this.btnTarget.classList.add(this.CL_OPEN);

    gsap.to([this.bg,this.window],{
      duration:this.time,
      ...(this.isSp?{y:0}:{opacity:1}),
      ease:this.easing,onComplete:()=>{
        this.onOpenAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN));
      }
    });

    this.setOverflowChange(this.isSp);
  }

  onClickSubmit(e) {
    this.beforeData = this.getData();
    this.onClose();
  }

  onClickClose(e) {
    this.rooms.forEach(room=>{
      room.el.removeEventListener(DialogPassengerRoom.EVENT_DELETE,this.deleteRoomEl);
      room.el.removeEventListener(DialogPassengerRoom.EVENT_UPDATE_COUNT,this.updateRoomEl);
      room.onDelete();
      room = null;
    });
    this.rooms = [];

    this.onInit(this.masterData,this.beforeData);
    this.onClose();
  }

  onClose(){
    this.onCloseBefore();

    this.rooms.forEach(room=>room.onDialogClose());

    this.btnTarget.classList.remove(this.CL_OPEN);

    gsap.killTweensOf([this.bg,this.window]);
    gsap.to([this.bg,this.window],{
      duration:this.time,
      ...(this.isSp?{y:"100%"}:{opacity:0}),
      ease:this.easing,onComplete:()=>{
        this.target.style.display = "none";
        this.isOpen = false;

        this.setOverflowChange(false);

        this.onCloseAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_CLOSE));
      }
    });
  }

  onOpenBefore(){
    this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN_BEFORE));
  }
  onOpenAfter(){
  }

  onCloseBefore(){
  }
  onCloseAfter(){
  }

  getCheckData(){
    let chdage = [];
    this.rooms.forEach(room=>{
      chdage.push(room.ageList.getData());
    });
    return {
      chdage
    }
  }

  getData(){
    let re = {};
    let adtnum = 0;
    let chdnum = 0;
    let roomnum = this.rooms.length;
    let chdage = [];
    this.rooms.forEach((room,index)=>{
      const n = index + 1;
      const an = room.adtCount.count;
      const cn = room.chdCount.count;
      adtnum += an;
      chdnum += cn;
      re["adtnum"+n] = an;
      re["chdnum"+n] = cn;
      re["chdage"+n] = room.ageList.getData().join(",");
    });

    re.adtnum = adtnum;
    re.chdnum = chdnum;
    re.roomnum = roomnum;

    return re;
  }
}
